import "reflect-metadata";
import {inject, injectable} from "inversify";
import {AuthRepository} from "@dropDesk/domain/repositories/auth/auth.repository";
import {MailAction} from "@dropDesk/domain/entities/common/actions_entity";


@injectable()
export class StartMigrationUseCase {
    private _repository: AuthRepository;

    constructor(
        @inject(AuthRepository) repository: AuthRepository
    ) {
        this._repository = repository;
    }

    public call(email: string, action?: MailAction): Promise<void> {
        return this._repository.startMigration(email, action);
    }
}
